import * as Yup from 'yup';

const USER_INFO_SCHEMA = Yup.object().shape({
	first_name: Yup.string().required('This field is required'),
	last_name: Yup.string().required('This field is required'),
	email: Yup.string().email('Invalid email').required('This field is required'),
	organization: Yup.string().required('This field is required')
});

export default USER_INFO_SCHEMA;
